import script from "./DealRoomInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./DealRoomInvite.vue?vue&type=script&setup=true&lang=js"

import "./DealRoomInvite.vue?vue&type=style&index=0&id=63546aaa&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63546aaa"]])

export default __exports__